import { Box } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const LinkListColumns = styled(Box) `
  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    column-count: 4;
  }
`;
//# sourceMappingURL=ChildPageLinkList.styled.js.map